import { firePixel } from "../pixels";
import { urlParam } from "../config";

//Fires on the page an order ends on: the affiliate's and the ad network's
//conversion, the one event they optimise on.
//
//The page says what it is rather than the library guessing from its filename:
//<body data-sdk-page="success">. The funnels do not agree on a name -
//success.html, success-el.html, thank-you.html - and a page merely having
//"success" in its name is not necessarily the confirmation of an order.
//
//Without a transaction there is nothing to report: someone reached the page
//directly. Reloads are safe - the CRM dedupes a pixel per transaction and
//type, so a customer refreshing their confirmation does not sell twice.
//
//Whether a purchase actually happened is not the page's call either: only a
//prepaid funnel gets here by returning from a payment, while a cash-on-delivery
//order reaching its confirmation page has not been paid for. The CRM knows the
//offer behind the transaction and answers with nothing for the second case, so
//this asks and lets it decide.
export function purchasePixel() {
	if (document.body.getAttribute("data-sdk-page") !== "success") {
		return;
	}
	if (!urlParam("transaction_id")) {
		return;
	}

	firePixel("purchase");
}
